import EventEmitter from 'utils/EventEmitter';

const ReportDisplayEventEmitter = new EventEmitter<{
  refresh: null;
}>();
// dummy before we open any ReportDisplay
ReportDisplayEventEmitter.on('refresh', () => null);

export default ReportDisplayEventEmitter;
